<div>
    <div class="navbar">
        <wg-navbar *ngIf="getLoginState()"></wg-navbar>
    </div>
    <div >
        <router-outlet></router-outlet>
    </div>
</div>